import api from '../../lib/api';
import type {
  DesignProjectPayload,
  DesignProjectSummary,
  PaginatedDesignProjects,
  TransitionDesignStagePayload,
} from './types';

export interface ListDesignProjectsParams {
  status?: string;
  search?: string;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

export const fetchDesignProjects = async (
  params: ListDesignProjectsParams = {},
): Promise<PaginatedDesignProjects> => {
  const { data } = await api.get<PaginatedDesignProjects>('design-projects', { params });
  return data;
};

export const createDesignProject = async (payload: DesignProjectPayload) => {
  const { data } = await api.post('design-projects', payload);
  return data;
};

export const updateDesignProject = async (
  id: string,
  payload: Partial<DesignProjectPayload> & { status?: string },
) => {
  const { data } = await api.put(`design-projects/${id}`, payload);
  return data;
};

export const transitionDesignStage = async (
  projectId: string,
  stageId: string,
  payload: TransitionDesignStagePayload,
): Promise<DesignProjectSummary> => {
  const { data } = await api.patch(`design-projects/${projectId}/stages/${stageId}`, payload);
  return data;
};

export const escalateDesignProject = async (
  id: string,
  payload?: { title?: string; description?: string },
) => {
  const { data } = await api.post(`design-projects/${id}/escalate`, payload ?? {});
  return data;
};
